module.exports = __webpack_public_path__ + "img/unvalid.a321f47d.svg";